module.exports = __webpack_public_path__ + "img/hohlschnitt_weiss-transluzent.17cb768a.jpg";